<app-special-investment-table
  [currentTabname]="tabName"
  [prevDocumentType]="prevDocumentType"
  [isRFPDescription]="true"></app-special-investment-table>
